// src/components/ErrorBoundary.jsx
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details
    // console.error('[ErrorBoundary] Caught error:', error);
    // console.error('[ErrorBoundary] Error info:', errorInfo);
    // console.error('[ErrorBoundary] Component stack:', errorInfo.componentStack);

    this.setState({
      error: error,
      errorInfo: errorInfo,
    });

    // You could also log to an error reporting service here
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#0b0f17',
          color: '#e5e7eb',
          padding: '2rem',
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }}>
          <div style={{
            maxWidth: '600px',
            background: '#111827',
            border: '1px solid rgba(248, 113, 113, 0.3)',
            borderRadius: '16px',
            padding: '2rem'
          }}>
            <h1 style={{ color: '#fca5a5', marginTop: 0 }}>Something went wrong</h1>
            <p style={{ color: '#cbd5e1' }}>
              The app encountered an error. Please try refreshing the page.
            </p>

            {this.state.error && (
              <details style={{ marginTop: '1.5rem' }}>
                <summary style={{ cursor: 'pointer', color: '#8b5cf6', fontWeight: 600 }}>
                  Show error details
                </summary>
                <div style={{
                  marginTop: '1rem',
                  padding: '1rem',
                  background: 'rgba(0,0,0,0.3)',
                  borderRadius: '8px',
                  overflow: 'auto'
                }}>
                  <p style={{ fontSize: '0.85rem', color: '#fca5a5', margin: '0 0 0.5rem' }}>
                    <strong>Error:</strong> {this.state.error.toString()}
                  </p>
                  {this.state.errorInfo && (
                    <pre style={{
                      fontSize: '0.75rem',
                      color: '#9ca3af',
                      whiteSpace: 'pre-wrap',
                      margin: 0
                    }}>
                      {this.state.errorInfo.componentStack}
                    </pre>
                  )}
                </div>
              </details>
            )}

            <button
              onClick={() => window.location.href = '/'}
              style={{
                marginTop: '1.5rem',
                padding: '0.75rem 1.5rem',
                background: 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: 600,
                cursor: 'pointer'
              }}
            >
              Go to Home Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
